export const indexById = (d: { id: string }) => d.id;
export const indexByApId = (d: { ap_id: string }) => d.ap_id;
export const indexByCode = (d: { code: string }) => d.code;
